.signet-card {
  position: relative;
  overflow: hidden;

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 50%;
    padding: 8px;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    background-color: var(--pure-white);

    .card-body {
      display: block;

      .body-header {
        .heading {
          font-size: 16px;
          margin: 0px;
          padding: 12px 0;
        }

        .subheading {
          color: var(--text-primary);
          margin-bottom: 2px;
          font-size: 12px;
        }
      }

      .body-text {
        color: var(--text-primary);
        padding: 6px 0;
      }
    }

    .card-footer {
      display: block;
      margin-top: 8px;
    }
  }
}
